export default function getParameter(paramName) {
  const search = window.location.search;
  const params = new URLSearchParams(search);
  return params.get(paramName);
}
